module.exports = __webpack_public_path__ + "img/CY120011.1f6bb994.png";